import React, {useState, useEffect} from 'react';
import { Route, Routes } from 'react-router-dom';
import Loader from '../components_mesa/common/loader.js';

import Login from '../components_mesa/mesa_registro/login';
import MesaRegistro from '../components_mesa/mesa_registro/mesa';
import FormCarnet from '../components_mesa/mesa_registro/mesa_form_alta';
import Configuracion from '../components_mesa/mesa_registro/configuracion';
import EtiquetasConfig from '../components_mesa/mesa_registro/etiquetas_config';
import Estadistica from '../components_mesa/mesa_registro/estadistica';
import EstadisticaRepro from '../components_mesa/mesa_registro/estadistica_rep';

const MainRoutes = () => {
    const [usuario, setUsuario] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch('/rt_getSession', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({})
        })
        .then(response => response.json())
        .then((response) => {
            setUsuario(response.usuario);
            setLoading(false);
        });
    }, []);

    if (loading) return <Loader />;

    return (
        <>
            <Routes>
                {/* Rutas con sesion */}
                <Route exact path='/'  >
                    <Route exact path={`${process.env.PUBLIC_URL}/`} element={<MesaRegistro usuario={usuario}/>}/>
                    <Route exact path={`${process.env.PUBLIC_URL}/mesaregistro`} element={<MesaRegistro usuario={usuario}/>}/>
                    <Route exact path={`${process.env.PUBLIC_URL}/mesaregistro/nuevo`} element={<FormCarnet esMesaRegistro={true}/>}/>
                    <Route exact path={`${process.env.PUBLIC_URL}/mesaregistro/editar/:id`} element={<FormCarnet esMesaRegistro={true} esEditar={1}/>}/>
                    <Route exact path={`${process.env.PUBLIC_URL}/mesaregistro/configuracion`} element={<Configuracion esMesaRegistro={true}/>}/>
                    <Route exact path={`${process.env.PUBLIC_URL}/mesaregistro/etiquetas_config`} element={<EtiquetasConfig esMesaRegistro={true}/>}/>
                    <Route exact path={`${process.env.PUBLIC_URL}/mesaregistro/estadistica`} element={<Estadistica esMesaRegistro={true}/>}/>
                    <Route exact path={`${process.env.PUBLIC_URL}/mesaregistro/estadistica/reproduccion`} element={<EstadisticaRepro esMesaRegistro={true}/>}/>
                </Route>
                {/* Rutas sin sesión */}
                <Route exact path={`${process.env.PUBLIC_URL}/login`} element={<Login />} />
            </Routes>
        </>
    );
};

export default MainRoutes;